import { defineMessages } from 'react-intl-next';

export default defineMessages({
	noResultsViewAltText: {
		id: 'team-selector.team-picker.no-results-view.alt-text',
		defaultMessage: 'No results found',
		description: 'Alt text for the no results view of the team picker.',
	},
	noResultsViewHeading: {
		id: 'team-selector.team-picker.no-results-view.heading',
		defaultMessage: "We couldn't find anything matching your search.",
		description: 'Heading displayed on the no results view of the team picker.',
	},
	noResultsViewActionText: {
		id: 'team-selector.team-picker.no-results-view.action-text',
		defaultMessage: 'Try again with a different term',
		description: 'Action text displayed on the no results view of the team picker.',
	},
});
